import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    Avatar,
    Chip,
    Icon,
    IconButton,
    LinearProgress,
    Table,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core'
import {FuseAnimate, FusePageCarded} from '@fuse'
import {Link, withRouter} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import ReduxCalender from "../../../../store/actionreducers/calender"
import ReduxNewCalender from "../../../../store/actionreducers/new-calendar"
import moment from "moment"
import TableBody from "@material-ui/core/TableBody"
import {constDataDialogs} from "../../../../constants"
import ReduxCallHelper from "../../../../store/actionreducers/callHelper"
import AddMedicalDialog from "./AddMedicalDialog"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import NewCalenderService from "../../../../service/new-calender"
import { checkIsAdminMedical } from "../../../../helper/mission"

const timePeriods = [
    { id: 1, key: 'one', label: '00:00~04:00' },
    { id: 2, key: 'two', label: '04:00~08:00' },
    { id: 3, key: 'three', label: '08:00~12:00' },
    { id: 4, key: 'four', label: '12:00~16:00' },
    { id: 5, key: 'five', label: '16:00~20:00' },
    { id: 6, key: 'six', label: '20:00~24:00' },
];

const medicalLevelColors = { 1: 'default', 2: 'primary', 3: 'secondary' };

class NewCalendarDateApp extends Component {

    state = {
        date: '',
        events: {},
        eventsByPeriod: { one: [], two: [], three: [], four: [], five: [], six: [] },
    };

    async componentDidMount() {
        await this._loadEvents()
    }

    async _loadEvents() {
        this.setState({ isLoading: true })
        const { fetchEventsDaily } = this.props

        const date = moment(this.props.match.params.date)
        const events = await fetchEventsDaily({ year: date.year(), month: date.month(), date: date.date() })
        const eventsByPeriod = { one: [], two: [], three: [], four: [], five: [], six: [] }
        events.normal.events.map(event => eventsByPeriod[event.time_period.label].push(event))
        this.setState({ isLoading: false, date: date.format('YYYY-MM-DD'), events, eventsByPeriod })
    }

    _onMedicalClick(id) {
        return () => {
            this.props.history.push({
                pathname: `/apps/medical/${id}`,
                state: { redirectUrl: this.props.location.pathname }
            })
        }
    }

    _onAddChipClick({ workEventType, period = null }) {
        const { openDataDialog, getMedicals } = this.props
        return async ev => {
            try {
                ev.stopPropagation()
                await getMedicals()
                openDataDialog({
                    type: constDataDialogs.type.edit,
                    name: constDataDialogs.name.addMedicalDialog,
                    payload: {
                        date: this.state.date,
                        period,
                        workEventType,
                    },
                })
            } catch (e) {
                console.warn('you got an error = ', e)
            }
        }
    }

    async onDeleteButtonClick(id) {
        await NewCalenderService.deleteWorkEvent(id);
        await this._loadEvents();
    }

    render() {
        const { date, events, eventsByPeriod } = this.state
        const { user } = this.props

        const isAdminMedical = checkIsAdminMedical(user)
        if (this.state.date.length === 0) return (<div/>)
        return (
            <FusePageCarded
                innerScroll
                header={
                    <div className="flex flex-1 p-32 items-center justify-around">
                        <div className="flex flex-col items-start max-w-full">
                            <div className="flex items-center max-w-full">
                                <div className="flex flex-col min-w-0">
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <div>
                                            <Typography className="text-24 truncate">
                                                {date} 排班表
                                            </Typography>
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </div>
                        </div>
                        <Typography className="normal-case flex text-24 items-center" component={Link}
                                    role="button" to="/apps/new-calendar">
                            <Icon className="mr-4 text-24">arrow_back</Icon>
                            回到 醫師排班
                        </Typography>
                        <IconButton onClick={() => this._loadEvents()}>
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <Icon className="text-32 mr-12">refresh</Icon>
                            </FuseAnimate>
                        </IconButton>
                    </div>
                }
                content={
                    <div className="flex flex-1 justify-around flex-row flex-wrap p-28">
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <div className="w-full p-16">
                                <Typography className="text-16 truncate mt-12 mb-12 text-teal-darker">
                                    排班醫師：
                                </Typography>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>時段</TableCell>
                                            <TableCell>排班醫師</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {timePeriods.map(period => (
                                            <TableRow key={`event-${date}-normal-${period.key}`}>
                                                <TableCell component="th" scope="row">{period.label}</TableCell>
                                                <TableCell>
                                                    <div className="flex flex-1 justify-start flex-row flex-wrap">
                                                        <div className="flex justify-start flex-row">
                                                            {eventsByPeriod[period.key]
                                                                .filter(event => {
                                                                    if (!isAdminMedical) return true
                                                                    const institutionOfUser = user && user.medical && user.medical.fk_institution_id || ''
                                                                    const institutionOfWorkEvent = event && event.medical && event.medical.fk_institution_id || ''
                                                                    return institutionOfUser === institutionOfWorkEvent
                                                                })
                                                                .map((event, ind) => <Chip
                                                                    key={`event-${date}-normal-${period.key}-${ind}`}
                                                                    avatar={<Avatar src={event.medical.user.avatar.url}/>}
                                                                    label={event.medical.user.name}
                                                                    onClick={this._onMedicalClick(event.medical.id)}
                                                                    color={medicalLevelColors[event.medical.fk_medical_level_id]}
                                                                    style={{marginRight: 5}}
                                                                    onDelete={() => this.onDeleteButtonClick(event.id)}
                                                                />)
                                                            }
                                                        </div>
                                                        <Chip
                                                            color={'secondary'}
                                                            onClick={this._onAddChipClick({
                                                                workEventType: 'normal',
                                                                period,
                                                            })}
                                                            label="+"
                                                        />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                            {[
                                { key: 'leader', text: '總值班', color: 'blue' },
                                { key: 'firefighter', text: '救火', color: 'pink' },
                            ].map(eventLevel => (<div key={`section-${eventLevel.key}`} className="flex-grow p-16">
                                <Typography className={`text-16 truncate mt-12 mb-12 text-${eventLevel.color}-dark`}>
                                    {eventLevel.text}醫師：
                                </Typography>
                                <div>
                                    {events[eventLevel.key].events.map((event, ind) => <Chip
                                        key={`${eventLevel.text}-${ind}`}
                                        avatar={<Avatar src={event.medical.user.avatar.url} />}
                                        label={event.medical.user.name}
                                        onClick={this._onMedicalClick(event.medical.id)}
                                        color={medicalLevelColors[event.medical.fk_medical_level_id]}
                                        style={{ marginRight: 5 }}
                                    />)}
                                </div>
                                <div>
                                    <Chip
                                        color={'secondary'}
                                        onClick={this._onAddChipClick({ workEventType: eventLevel.key })}
                                        label="+"
                                    />
                                </div>
                            </div>))}
                        </div>
                        <AddMedicalDialog onClose={() => this._loadEvents()} />
                    </div>
                }
            />
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedicals: ReduxCallHelper.ActionCreator.getMedicals,
        fetchEventsDaily: ReduxNewCalender.ActionCreator.fetchEventsDaily,
        getDateWorkEvents: ReduxCalender.ActionCreator.getDateWorkEvents,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch);
}

function mapStateToProps({ auth: { user } }) {
    return { user }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCalendarDateApp));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/NewCalendarDateApp.js